import React from 'react';
import PanelSlots from '@/components/Panel/PanelSlots';
import { PACU, PRE_OP } from '@/components/entities/room/enums';

const RoomPanelSlots = ({
  room,
  carouselSize,
  panelNumber,
  imageEmpty,
  hasPreOpPriorityModule,
  hasNoteModule,
  messagingView,
  screenType,
  staffMode,
  showLatePreOpIndicator,
  showPatientNotesOnInternalScreen,
  isSuperAdmin,
  getStaffForRoom,
  showStaffTracking,
  isKiosk = true,
  showPatientAgeAndSex,
  showPatientProcedureTimes,
  showPatientScheduledOr,
}) => {
  const { name, capacity, patients, type } = room;
  const newPanels = [];

  for (let i = 0; i < panelNumber; i++) {
    const oneEmptyPanel = panelNumber === 1 && patients?.length === 0;
    const twoEmptyPanel = panelNumber === 2 && patients?.length === 0 && i === 0;
    const threeEmptyPanel = panelNumber === 3 && patients?.length === 0 && i === 1;
    newPanels.push(
      <PanelSlots
        key={i}
        capacity={capacity}
        patientsCount={patients?.length || 0}
        patients={
          panelNumber === 1
            ? patients
            : patients.slice(i * carouselSize, i + 1 !== panelNumber ? (i + 1) * carouselSize : undefined)
        }
        name={i === 0 ? name : undefined}
        roomType={type}
        image={imageEmpty}
        showBed={true}
        showPriority={hasPreOpPriorityModule}
        showPreOpNote={type === PRE_OP && hasNoteModule}
        showPacuNote={type === PACU && hasNoteModule}
        highlightReady
        carouselSize={carouselSize}
        fusePanels={i + 1 !== panelNumber}
        lastInRow={i + 1 === panelNumber}
        showEmptyContent={oneEmptyPanel || twoEmptyPanel || threeEmptyPanel}
        messagingView={messagingView}
        screenType={screenType}
        staffMode={staffMode}
        showLatePreOpIndicator={showLatePreOpIndicator}
        showPatientNotesOnInternalScreen={showPatientNotesOnInternalScreen}
        isSuperAdmin={isSuperAdmin}
        roomStaff={showStaffTracking && getStaffForRoom && room.id ? getStaffForRoom(room.id) : []}
        isKiosk={isKiosk}
        showPatientAgeAndSex={showPatientAgeAndSex}
        showPatientProcedureTimes={showPatientProcedureTimes}
        showPatientScheduledOr={showPatientScheduledOr}
      />
    );
  }

  return newPanels;
};

export default RoomPanelSlots;
